export const MONACO_EDITOR_OPTIONS = {
  theme: 'customTheme',
  language: 'python',
  automaticLayout: true,
  scrollBeyondLastLine: false,
  minimap: { enabled: false },
  lineNumbers: 'on',
  wordWrap: 'on',
  renderLineHighlight: 'none',
  hideCursorInOverviewRuler: true,
  overviewRulerBorder: false,
} as const;

export const MONACO_EDITOR_OPTIONS_READONLY = {
  ...MONACO_EDITOR_OPTIONS,
  readOnly: true
} as const;

export const MONACO_EDITOR_OPTIONS_MARKDOWN = {
  ...MONACO_EDITOR_OPTIONS,
  language: 'markdown',
  lineNumbers: 'off',
  wrappingIndent: 'same',
  matchBrackets: 'never',

  guides: {
    bracketPairs: false,
    bracketPairsHorizontal: false
  },

  // 🔥 THIS FIXES ' ' " " yellow highlighting
  unicodeHighlight: {
    nonBasicASCII: false,
    ambiguousCharacters: false,
    invisibleCharacters: false
  }
} as const;

export const MONACO_EDITOR_OPTIONS_MARKDOWN_READONLY = {
  ...MONACO_EDITOR_OPTIONS_MARKDOWN,
  readOnly: true
} as const;
